import React from 'react'
import { mdx } from '@mdx-js/react'
/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: true,
  subnav: true,
  maxTocLevel: 4,
  layout: 'reference',
  secondLevelToc: true,
  alwaysExpand: true,
  parentTocLevel: 3,
  childTocLevel: 4,
  description: 'API reference for endpoints and webhooks associated with the Plaid Monitor product.',
  source: 'endpoint'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const Schema = makeShortcode("Schema");
const MDXCodeBlock = makeShortcode("MDXCodeBlock");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='Monitor' subtitle='API reference for Monitor endpoints and webhooks' compact mdxType="Header" />
    <p>{`For how-to guidance, see the `}<a parentName="p" {...{
        "href": "/docs/monitor/"
      }}>{`Monitor documentation`}</a>{`.`}</p>
    <div className="long-endpoint-table">
      <table>
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Endpoints`}</th>
            <th parentName="tr" {...{
              "align": null
            }}></th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/watchlist_screening/individual/create`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Create a watchlist screening for a person`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/watchlist_screening/individual/get`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Retrieve an individual watchlist screening`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/watchlist_screening/individual/list`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`List individual watchlist screenings`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/watchlist_screening/individual/update`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Update individual watchlist screening`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/watchlist_screening/individual/history/list`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`List history for individual watchlist screenings`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/watchlist_screening/individual/review/create`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Create a review for an individual watchlist screening`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/watchlist_screening/individual/review/list`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`List reviews for individual watchlist screenings`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/watchlist_screening/individual/hit/list`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`List hits for individual watchlist screenings`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/watchlist_screening/individual/program/get`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Get individual watchlist screening programs`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/watchlist_screening/individual/program/list`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`List individual watchlist screening programs`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/watchlist_screening/entity/create`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Create a watchlist screening for an entity`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/watchlist_screening/entity/get`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Retrieve an entity watchlist screening`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/watchlist_screening/entity/list`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`List entity watchlist screenings`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/watchlist_screening/entity/update`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Update entity watchlist screening`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/watchlist_screening/entity/history/list`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`List history for entity watchlist screenings`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/watchlist_screening/entity/review/create`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Create a review for an entity watchlist screening`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/watchlist_screening/entity/review/list`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`List reviews for entity watchlist screenings`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/watchlist_screening/entity/hit/list`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`List hits for entity watchlist screenings`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/watchlist_screening/entity/program/get`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Get entity watchlist screening programs`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/watchlist_screening/entity/program/list`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`List entity watchlist screening programs`}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`See also`}</th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/dashboard_user/get`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Retrieve information about a dashboard user`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/dashboard_user/list`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`List dashboard users`}</td>
        </tr>
      </tbody>
    </table>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Webhooks`}</th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#screening-status_updated"
            }}><inlineCode parentName="a">{`SCREENING: STATUS_UPDATED`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The status of an individual watchlist screening has changed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#entity_screening-status_updated"
            }}><inlineCode parentName="a">{`ENTITY_SCREENING: STATUS_UPDATED`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The status of an entity watchlist screening has changed`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "endpoints"
    }}>{`Endpoints`}</h3>
    <h4 {...{
      "id": "watchlist_screeningindividualcreate"
    }}>{`/watchlist_screening/individual/create`}</h4>
    <Schema method='POST' route='/watchlist_screening/individual/create' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/watchlist_screening/individual/create' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: WatchlistScreeningIndividualCreateRequest = {
  search_terms: {
    watchlist_program_id: 'prg_2eRPsDnL66rZ7H',
    legal_name: 'Aleksey Potemkin',
    date_of_birth: '1990-05-29',
    document_number: 'C31195855',
    country: 'US',
  },
  client_user_id: 'example-client-user-id-123',
};

try {
  const response = await client.watchlistScreeningIndividualCreate(request);
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`const request: Plaid.WatchlistScreeningIndividualCreateRequest = {
  search_terms: {
    watchlist_program_id: 'prg_2eRPsDnL66rZ7H',
    legal_name: 'Aleksey Potemkin',
    date_of_birth: '1990-05-29',
    document_number: 'C31195855',
    country: 'US',
  },
  client_user_id: 'example-client-user-id-123',
};

try {
  const response = await client.watchlistScreeningIndividual.create(request);
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/watchlist_screening/individual/create \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "search_terms": {
    "watchlist_program_id": "prg_2eRPsDnL66rZ7H",
    "legal_name": "Aleksey Potemkin",
    "date_of_birth": "1990-05-29",
    "document_number": "C31195855",
    "country": "US"
  },
  "client_user_id": "example-client-user-id-123"
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::WatchlistScreeningIndividualCreateRequest.new(
  {
    search_terms: {
      watchlist_program_id: 'prg_2eRPsDnL66rZ7H',
      legal_name: 'Aleksey Potemkin',
      date_of_birth: '1990-05-29',
      document_number: 'C31195855',
      country: 'US',
    },
    client_user_id: 'example-client-user-id-123',
  }
)
response = client.watchlist_screening_individual_create(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`WatchlistScreeningRequestSearchTerms searchTerms = new WatchlistScreeningRequestSearchTerms()
  .watchlistProgramId("prg_2eRPsDnL66rZ7H")
  .legalName("Aleksey Potemkin")
  .dateOfBirth(LocalDate.parse("1990-05-29"))
  .documentNumber("C31195855")
  .country("US");

WatchlistScreeningIndividualCreateRequest request = new WatchlistScreeningIndividualCreateRequest()
  .searchTerms(searchTerms)
  .clientUserId("example-client-user-id-123");

Response<WatchlistScreeningIndividualCreateResponse> response = client()
  .watchlistScreeningIndividualCreate(request)
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = WatchlistScreeningIndividualCreateRequest(
  search_terms=WatchlistScreeningRequestSearchTerms(
    watchlist_program_id='prg_2eRPsDnL66rZ7H',
    legal_name='Aleksey Potemkin',
    date_of_birth=datetime.date(1990, 5, 29),
    document_number='C31195855',
    country='US',
  ),
  client_user_id='example-client-user-id-123',
)
response = client.watchlist_screening_individual_create(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`searchTerms := plaid.NewWatchlistScreeningRequestSearchTerms(
  "prg_2eRPsDnL66rZ7H",
  "Aleksey Potemkin",
)
searchTerms.SetDateOfBirth("1990-05-29")
searchTerms.SetDocumentNumber("C31195855")
searchTerms.SetCountry("US")

request := plaid.NewWatchlistScreeningIndividualCreateRequest(*searchTerms)
request.SetClientUserId("example-client-user-id-123")

response, _, err := client.PlaidApi.
  WatchlistScreeningIndividualCreate(ctx).
  WatchlistScreeningIndividualCreateRequest(*request).
  Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`searchTerms := &plaid.WatchlistScreeningRequestSearchTerms{
    WatchlistProgramID: "prg_2eRPsDnL66rZ7H",
    LegalName:          "Aleksey Potemkin",
}
searchTerms.DateOfBirth = plaid.Time(time.Date(1990, 5, 29, 0, 0, 0, 0, time.UTC))
searchTerms.DocumentNumber = plaid.String("C31195855")
searchTerms.Country = plaid.String("US")

request := &plaid.WatchlistScreeningIndividualCreateRequest{SearchTerms: searchTerms}
request.ClientUserID = plaid.String("example-client-user-id-123")

response, err := client.WatchlistScreeningIndividual.Create(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/watchlist_screening/individual/create' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "watchlist_screeningindividualget"
    }}>{`/watchlist_screening/individual/get`}</h4>
    <Schema method='POST' route='/watchlist_screening/individual/get' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/watchlist_screening/individual/get' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: WatchlistScreeningIndividualGetRequest = {
  watchlist_screening_id: 'scr_52xR9LKo77r1Np',
};

try {
  const response = await client.watchlistScreeningIndividualGet(request);
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`const request: Plaid.WatchlistScreeningIndividualGetRequest = {
  watchlist_screening_id: 'scr_52xR9LKo77r1Np',
};

try {
  const response = await client.watchlistScreeningIndividual.get(request);
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/watchlist_screening/individual/get \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "watchlist_screening_id": "scr_52xR9LKo77r1Np"
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::WatchlistScreeningIndividualGetRequest.new(
  {
    watchlist_screening_id: "scr_52xR9LKo77r1Np"
  }
)
response = client.watchlist_screening_individual_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`WatchlistScreeningIndividualGetRequest request = new WatchlistScreeningIndividualGetRequest()
  .watchlistScreeningId("scr_52xR9LKo77r1Np");

Response<WatchlistScreeningIndividualGetResponse> response = client()
  .watchlistScreeningIndividualGet(request)
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = WatchlistScreeningIndividualGetRequest(
  watchlist_screening_id='scr_52xR9LKo77r1Np',
)
response = client.watchlist_screening_individual_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewWatchlistScreeningIndividualGetRequest("scr_52xR9LKo77r1Np")

response, _, err := client.PlaidApi.
  WatchlistScreeningIndividualGet(ctx).
  WatchlistScreeningIndividualGetRequest(*request).
  Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.WatchlistScreeningIndividualGetRequest{WatchlistScreeningID: "scr_52xR9LKo77r1Np"}

response, err := client.WatchlistScreeningIndividual.Get(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/watchlist_screening/individual/get' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "watchlist_screeningindividuallist"
    }}>{`/watchlist_screening/individual/list`}</h4>
    <Schema method='POST' route='/watchlist_screening/individual/list' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/watchlist_screening/individual/list' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: WatchlistScreeningIndividualListRequest = {
  watchlist_program_id: 'prg_2eRPsDnL66rZ7H',
  client_user_id: 'example-client-user-id-123',
};

try {
  const response = await client.watchlistScreeningIndividualList(request);
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`const request: Plaid.WatchlistScreeningIndividualListRequest = {
  watchlist_program_id: 'prg_2eRPsDnL66rZ7H',
  client_user_id: 'example-client-user-id-123',
};

try {
  const response = (await client.watchlistScreeningIndividual.list(request))
    .response;
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/watchlist_screening/individual/list \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "watchlist_program_id": "prg_2eRPsDnL66rZ7H",
  "client_user_id": "example-client-user-id-123"
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::WatchlistScreeningIndividualListRequest.new(
  {
    watchlist_program_id: 'prg_2eRPsDnL66rZ7H',
    client_user_id: 'example-client-user-id-123'
  }
)

response = client.watchlist_screening_individual_list(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`WatchlistScreeningIndividualListRequest request = new WatchlistScreeningIndividualListRequest()
  .watchlistProgramId("prg_2eRPsDnL66rZ7H")
  .clientUserId("example-client-user-id-123");

Response<WatchlistScreeningIndividualListResponse> response = client()
  .watchlistScreeningIndividualList(request)
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = WatchlistScreeningIndividualListRequest(
  watchlist_program_id='prg_2eRPsDnL66rZ7H',
  client_user_id='example-client-user-id-123',
)
response = client.watchlist_screening_individual_list(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewWatchlistScreeningIndividualListRequest("prg_2eRPsDnL66rZ7H")

response, _, err := client.PlaidApi.
  WatchlistScreeningIndividualList(ctx).
  WatchlistScreeningIndividualListRequest(*request).
  Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.WatchlistScreeningIndividualListRequest{WatchlistProgramID: "prg_2eRPsDnL66rZ7H"}

response, err := client.WatchlistScreeningIndividual.List(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/watchlist_screening/individual/list' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "watchlist_screeningindividualupdate"
    }}>{`/watchlist_screening/individual/update`}</h4>
    <Schema method='POST' route='/watchlist_screening/individual/update' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/watchlist_screening/individual/update' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: WatchlistScreeningIndividualUpdateRequest = {
  watchlist_screening_id: 'scr_52xR9LKo77r1Np',
  status: 'cleared',
};

try {
  const response = await client.watchlistScreeningIndividualUpdate(request);
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`const request: Plaid.WatchlistScreeningIndividualUpdateRequest = {
  watchlist_screening_id: 'scr_52xR9LKo77r1Np',
  status: 'cleared',
};

try {
  const response = await client.watchlistScreeningIndividual.update(request);
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/watchlist_screening/individual/update \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "watchlist_screening_id": "scr_52xR9LKo77r1Np",
  "status": "cleared"
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::WatchlistScreeningIndividualUpdateRequest.new(
  {
    watchlist_screening_id: 'scr_52xR9LKo77r1Np',
    status: 'cleared'
  }
)

response = client.watchlist_screening_individual_update(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`WatchlistScreeningIndividualUpdateRequest request = new WatchlistScreeningIndividualUpdateRequest()
  .watchlistScreeningId("scr_52xR9LKo77r1Np")
  .status(WatchlistScreeningStatus.CLEARED);

Response<WatchlistScreeningIndividualUpdateResponse> response = client()
  .watchlistScreeningIndividualUpdate(request)
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = WatchlistScreeningIndividualUpdateRequest(
  watchlist_screening_id='scr_52xR9LKo77r1Np',
  status=WatchlistScreeningStatus('cleared'),
)
response = client.watchlist_screening_individual_update(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewWatchlistScreeningIndividualUpdateRequest("scr_52xR9LKo77r1Np")
request.SetStatus("cleared")

response, _, err := client.PlaidApi.
  WatchlistScreeningIndividualUpdate(ctx).
  WatchlistScreeningIndividualUpdateRequest(*request).
  Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.WatchlistScreeningIndividualUpdateRequest{WatchlistScreeningID: "scr_52xR9LKo77r1Np"}
request.Status = plaid.WatchlistScreeningStatus("cleared").Ptr()

response, err := client.WatchlistScreeningIndividual.Update(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/watchlist_screening/individual/update' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "watchlist_screeningindividualhistorylist"
    }}>{`/watchlist_screening/individual/history/list`}</h4>
    <Schema method='POST' route='/watchlist_screening/individual/history/list' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/watchlist_screening/individual/history/list' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: WatchlistScreeningIndividualHistoryListRequest = {
  watchlist_screening_id: 'scr_52xR9LKo77r1Np',
};

try {
  const response = await client.watchlistScreeningIndividualHistoryList(
    request,
  );
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`const request: Plaid.WatchlistScreeningIndividualHistoryListRequest = {
  watchlist_screening_id: 'scr_52xR9LKo77r1Np',
};

try {
  const response = (
    await client.watchlistScreeningIndividual.listHistory(request)
  ).response;
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/watchlist_screening/individual/history/list \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "watchlist_screening_id": "scr_52xR9LKo77r1Np"
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::WatchlistScreeningIndividualHistoryListRequest.new(
  {
    watchlist_screening_id: 'scr_52xR9LKo77r1Np'
  }
)

response = client.watchlist_screening_individual_history_list(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`WatchlistScreeningIndividualHistoryListRequest request = new WatchlistScreeningIndividualHistoryListRequest()
  .watchlistScreeningId("scr_52xR9LKo77r1Np");

Response<WatchlistScreeningIndividualHistoryListResponse> response = client()
  .watchlistScreeningIndividualHistoryList(request)
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = WatchlistScreeningIndividualHistoryListRequest(
  watchlist_screening_id='scr_52xR9LKo77r1Np'
)
response = client.watchlist_screening_individual_history_list(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewWatchlistScreeningIndividualHistoryListRequest("scr_52xR9LKo77r1Np")

response, _, err := client.PlaidApi.
  WatchlistScreeningIndividualHistoryList(ctx).
  WatchlistScreeningIndividualHistoryListRequest(*request).
  Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.WatchlistScreeningIndividualHistoryListRequest{WatchlistScreeningID: "scr_52xR9LKo77r1Np"}

response, err := client.WatchlistScreeningIndividual.ListHistory(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/watchlist_screening/individual/history/list' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "watchlist_screeningindividualreviewcreate"
    }}>{`/watchlist_screening/individual/review/create`}</h4>
    <Schema method='POST' route='/watchlist_screening/individual/review/create' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/watchlist_screening/individual/review/create' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: WatchlistScreeningIndividualReviewCreateRequest = {
  confirmed_hits: ['scrhit_52xR9LKo77r1Np'],
  dismissed_hits: [],
  watchlist_screening_id: 'scr_52xR9LKo77r1Np',
};

try {
  const response = await client.watchlistScreeningIndividualReviewCreate(
    request,
  );
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`const request: Plaid.WatchlistScreeningIndividualReviewCreateRequest = {
  confirmed_hits: ['scrhit_52xR9LKo77r1Np'],
  dismissed_hits: [],
  watchlist_screening_id: 'scr_52xR9LKo77r1Np',
};

try {
  const response = await client.watchlistScreeningIndividual.createReview(
    request,
  );
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/watchlist_screening/individual/review/create \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "confirmed_hits": [
    "scrhit_52xR9LKo77r1Np"
  ],
  "dismissed_hits": [],
  "watchlist_screening_id": "scr_52xR9LKo77r1Np"
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::WatchlistScreeningIndividualReviewCreateRequest.new(
  {
    confirmed_hits: ['scrhit_52xR9LKo77r1Np'],
    dismissed_hits: [],
    watchlist_screening_id: "scr_52xR9LKo77r1Np",
  }
)

response = client.watchlist_screening_individual_review_create(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`List<String> confirmedHits = new ArrayList<String>();
confirmedHits.add("scrhit_52xR9LKo77r1Np");

List<String> dismissedHits = new ArrayList<String>();

WatchlistScreeningIndividualReviewCreateRequest request = new WatchlistScreeningIndividualReviewCreateRequest()
  .confirmedHits(confirmedHits)
  .dismissedHits(dismissedHits)
  .watchlistScreeningId("scr_52xR9LKo77r1Np");

Response<WatchlistScreeningIndividualReviewCreateResponse> response = client()
  .watchlistScreeningIndividualReviewCreate(request)
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = WatchlistScreeningIndividualReviewCreateRequest(
  confirmed_hits=['scrhit_52xR9LKo77r1Np'],
  dismissed_hits=[],
  watchlist_screening_id="scr_52xR9LKo77r1Np",
)
response = client.watchlist_screening_individual_review_create(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewWatchlistScreeningIndividualReviewCreateRequest(
  []string{"scrhit_52xR9LKo77r1Np"},
  []string{},
  "scr_52xR9LKo77r1Np",
)

response, _, err := client.PlaidApi.
  WatchlistScreeningIndividualReviewCreate(ctx).
  WatchlistScreeningIndividualReviewCreateRequest(*request).
  Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.WatchlistScreeningIndividualReviewCreateRequest{
    ConfirmedHits:        []string{"scrhit_52xR9LKo77r1Np"},
    DismissedHits:        []string{},
    WatchlistScreeningID: "scr_52xR9LKo77r1Np",
}

response, err := client.WatchlistScreeningIndividual.CreateReview(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/watchlist_screening/individual/review/create' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "watchlist_screeningindividualreviewlist"
    }}>{`/watchlist_screening/individual/review/list`}</h4>
    <Schema method='POST' route='/watchlist_screening/individual/review/list' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/watchlist_screening/individual/review/list' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: WatchlistScreeningIndividualReviewListRequest = {
  watchlist_screening_id: 'scr_52xR9LKo77r1Np',
};

try {
  const response = await client.watchlistScreeningIndividualReviewList(request);
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`const request: Plaid.WatchlistScreeningIndividualReviewListRequest = {
  watchlist_screening_id: 'scr_52xR9LKo77r1Np',
};

try {
  const response = (
    await client.watchlistScreeningIndividual.listReviews(request)
  ).response;
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/watchlist_screening/individual/review/list \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "watchlist_screening_id": "scr_52xR9LKo77r1Np"
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::WatchlistScreeningIndividualReviewListRequest.new(
  {
    watchlist_screening_id: 'scr_52xR9LKo77r1Np'
  }
)

response = client.watchlist_screening_individual_review_list(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`WatchlistScreeningIndividualReviewListRequest request = new WatchlistScreeningIndividualReviewListRequest()
  .watchlistScreeningId("scr_52xR9LKo77r1Np");

Response<WatchlistScreeningIndividualReviewListResponse> response = client()
  .watchlistScreeningIndividualReviewList(request)
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = WatchlistScreeningIndividualReviewListRequest(
  watchlist_screening_id='scr_52xR9LKo77r1Np',
)
response = client.watchlist_screening_individual_review_list(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewWatchlistScreeningIndividualReviewListRequest("scr_52xR9LKo77r1Np")

response, _, err := client.PlaidApi.
  WatchlistScreeningIndividualReviewList(ctx).
  WatchlistScreeningIndividualReviewListRequest(*request).
  Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.WatchlistScreeningIndividualReviewListRequest{WatchlistScreeningID: "scr_52xR9LKo77r1Np"}

response, err := client.WatchlistScreeningIndividual.ListReviews(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/watchlist_screening/individual/review/list' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "watchlist_screeningindividualhitlist"
    }}>{`/watchlist_screening/individual/hit/list`}</h4>
    <Schema method='POST' route='/watchlist_screening/individual/hit/list' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/watchlist_screening/individual/hit/list' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: WatchlistScreeningIndividualHitListRequest = {
  watchlist_screening_id: 'scr_52xR9LKo77r1Np',
};

try {
  const response = await client.watchlistScreeningIndividualHitList(request);
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`const request: Plaid.WatchlistScreeningIndividualHitListRequest = {
  watchlist_screening_id: 'scr_52xR9LKo77r1Np',
};

try {
  const response = (await client.watchlistScreeningIndividual.listHits(request))
    .response;
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/watchlist_screening/individual/hit/list \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "watchlist_screening_id": "scr_52xR9LKo77r1Np"
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::WatchlistScreeningIndividualHitListRequest.new(
  {
    watchlist_screening_id: 'scr_52xR9LKo77r1Np'
  }
)

response = client.watchlist_screening_individual_hit_list(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`WatchlistScreeningIndividualHitListRequest request = new WatchlistScreeningIndividualHitListRequest()
  .watchlistScreeningId("scr_52xR9LKo77r1Np");

Response<WatchlistScreeningIndividualHitListResponse> response = client()
  .watchlistScreeningIndividualHitList(request)
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = WatchlistScreeningIndividualHitListRequest(
  watchlist_screening_id='scr_52xR9LKo77r1Np',
)
response = client.watchlist_screening_individual_hit_list(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewWatchlistScreeningIndividualHitListRequest("scr_52xR9LKo77r1Np")

response, _, err := client.PlaidApi.
  WatchlistScreeningIndividualHitList(ctx).
  WatchlistScreeningIndividualHitListRequest(*request).
  Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.WatchlistScreeningIndividualHitListRequest{WatchlistScreeningID: "scr_52xR9LKo77r1Np"}

response, err := client.WatchlistScreeningIndividual.ListHits(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/watchlist_screening/individual/hit/list' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "watchlist_screeningindividualprogramget"
    }}>{`/watchlist_screening/individual/program/get`}</h4>
    <Schema method='POST' route='/watchlist_screening/individual/program/get' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/watchlist_screening/individual/program/get' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: WatchlistScreeningIndividualProgramGetRequest = {
  watchlist_program_id: 'prg_2eRPsDnL66rZ7H',
};

try {
  const response = await client.watchlistScreeningIndividualProgramGet(request);
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`const request: Plaid.WatchlistScreeningIndividualProgramGetRequest = {
  watchlist_program_id: 'prg_2eRPsDnL66rZ7H',
};

try {
  const response = await client.watchlistScreeningIndividual.getProgram(
    request,
  );
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/watchlist_screening/individual/program/get \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "watchlist_program_id": "prg_2eRPsDnL66rZ7H"
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::WatchlistScreeningIndividualProgramGetRequest.new(
  {
    watchlist_program_id: 'prg_2eRPsDnL66rZ7H'
  }
)

response = client.watchlist_screening_individual_program_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`WatchlistScreeningIndividualProgramGetRequest request = new WatchlistScreeningIndividualProgramGetRequest()
  .watchlistProgramId("prg_2eRPsDnL66rZ7H");

Response<WatchlistScreeningIndividualProgramGetResponse> response = client()
  .watchlistScreeningIndividualProgramGet(request)
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = WatchlistScreeningIndividualProgramGetRequest(
  watchlist_program_id='prg_2eRPsDnL66rZ7H',
)
response = client.watchlist_screening_individual_program_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewWatchlistScreeningIndividualProgramGetRequest("prg_2eRPsDnL66rZ7H")

response, _, err := client.PlaidApi.
  WatchlistScreeningIndividualProgramGet(ctx).
  WatchlistScreeningIndividualProgramGetRequest(*request).
  Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.WatchlistScreeningIndividualProgramGetRequest{WatchlistProgramID: "prg_2eRPsDnL66rZ7H"}

response, err := client.WatchlistScreeningIndividual.GetProgram(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/watchlist_screening/individual/program/get' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "watchlist_screeningindividualprogramlist"
    }}>{`/watchlist_screening/individual/program/list`}</h4>
    <Schema method='POST' route='/watchlist_screening/individual/program/list' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/watchlist_screening/individual/program/list' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`try {
  const response = await client.watchlistScreeningIndividualProgramList({});
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`try {
  const response = (await client.watchlistScreeningIndividual.listPrograms({}))
    .response;
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/watchlist_screening/individual/program/list \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`response = client.watchlist_screening_individual_program_list({})
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`Response<WatchlistScreeningIndividualProgramListResponse> response = client()
  .watchlistScreeningIndividualProgramList(new WatchlistScreeningIndividualProgramListRequest())
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = WatchlistScreeningIndividualProgramListRequest(
  cursor='eyJkaXJlY3Rpb24iOiJuZXh0Iiwib2Zmc2V0IjoiMTU5NDM'
)
response = client.watchlist_screening_individual_program_list(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewWatchlistScreeningIndividualProgramListRequest()

response, _, err := client.PlaidApi.
  WatchlistScreeningIndividualProgramList(ctx).
  WatchlistScreeningIndividualProgramListRequest(*request).
  Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.WatchlistScreeningIndividualProgramListRequest{}

response, err := client.WatchlistScreeningIndividual.ListPrograms(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/watchlist_screening/individual/program/list' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "watchlist_screeningentitycreate"
    }}>{`/watchlist_screening/entity/create`}</h4>
    <Schema method='POST' route='/watchlist_screening/entity/create' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/watchlist_screening/entity/create' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: WatchlistScreeningEntityCreateRequest = {
  search_terms: {
    entity_watchlist_program_id: 'entprg_2eRPsDnL66rZ7H',
    legal_name: 'Example Screening Entity',
    document_number: 'C31195855',
    email_address: 'user@example.com',
    country: 'US',
    phone_number: '+14025671234',
    url: 'https://example.com',
  },
  client_user_id: 'example-client-user-id-123',
};

try {
  const response = await client.watchlistScreeningEntityCreate(request);
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`const request: Plaid.WatchlistScreeningEntityCreateRequest = {
  search_terms: {
    entity_watchlist_program_id: 'entprg_2eRPsDnL66rZ7H',
    legal_name: 'Example Screening Entity',
    document_number: 'C31195855',
    email_address: 'user@example.com',
    country: 'US',
    phone_number: '+14025671234',
    url: 'https://example.com',
  },
  client_user_id: 'example-client-user-id-123',
};

try {
  const response = await client.watchlistScreeningEntity.create(request);
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/watchlist_screening/entity/create \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "search_terms": {
    "entity_watchlist_program_id": "entprg_2eRPsDnL66rZ7H",
    "legal_name": "Example Screening Entity",
    "document_number": "C31195855",
    "email_address": "user@example.com",
    "country": "US",
    "phone_number": "+14025671234",
    "url": "https://example.com"
  },
  "client_user_id": "example-client-user-id-123"
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::WatchlistScreeningEntityCreateRequest.new(
  {
    search_terms: {
      entity_watchlist_program_id: 'entprg_2eRPsDnL66rZ7H',
      legal_name: 'Example Screening Entity',
      document_number: 'C31195855',
      email_address: 'user@example.com',
      country: 'US',
      phone_number: '+14025671234',
      url: 'https://example.com',
    },
    client_user_id: 'example-client-user-id-123',
  }
)

response = client.watchlist_screening_entity_create(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`EntityWatchlistSearchTerms searchTerms = new EntityWatchlistSearchTerms()
  .entityWatchlistProgramId("entprg_2eRPsDnL66rZ7H")
  .legalName("Example Screening Entity")
  .emailAddress("user@example.com")
  .documentNumber("C31195855")
  .country("US")
  .phoneNumber("+14025671234")
  .url(URI.create("https://example.com"));

WatchlistScreeningEntityCreateRequest request = new WatchlistScreeningEntityCreateRequest()
  .searchTerms(searchTerms)
  .clientUserId("example-client-user-id-123");

Response<WatchlistScreeningEntityCreateResponse> response = client()
  .watchlistScreeningEntityCreate(request)
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = WatchlistScreeningEntityCreateRequest(
  search_terms=EntityWatchlistSearchTerms(
    entity_watchlist_program_id='entprg_2eRPsDnL66rZ7H',
    legal_name='Example Screening Entity',
    document_number='C31195855',
    email_address='user@example.com',
    country='US',
    phone_number='+14025671234',
    url='https://example.com',
  ),
  client_user_id='example-client-user-id-123'
)
response = client.watchlist_screening_entity_create(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`searchTerms := plaid.NewEntityWatchlistSearchTerms(
  "entprg_2eRPsDnL66rZ7H",
  "Example Screening Entity",
)
searchTerms.SetEmailAddress("user@example.com")
searchTerms.SetPhoneNumber("+14025671234")
searchTerms.SetDocumentNumber("C31195855")
searchTerms.SetUrl("https://example.com")
searchTerms.SetCountry("US")

request := plaid.NewWatchlistScreeningEntityCreateRequest(*searchTerms)
request.SetClientUserId("example-client-user-id-123")

response, _, err := client.PlaidApi.
  WatchlistScreeningEntityCreate(ctx).
  WatchlistScreeningEntityCreateRequest(*request).
  Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`searchTerms := &plaid.EntityWatchlistSearchTerms{
    EntityWatchlistProgramID: "entprg_2eRPsDnL66rZ7H",
    LegalName:                "Example Screening Entity",
}
searchTerms.EmailAddress = plaid.String("user@example.com")
searchTerms.PhoneNumber = plaid.String("+14025671234")
searchTerms.DocumentNumber = plaid.String("C31195855")
searchTerms.URL = plaid.String("https://example.com")
searchTerms.Country = plaid.String("US")

request := &plaid.WatchlistScreeningEntityCreateRequest{SearchTerms: searchTerms}
request.ClientUserID = plaid.String("example-client-user-id-123")

response, err := client.WatchlistScreeningEntity.Create(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/watchlist_screening/entity/create' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "watchlist_screeningentityget"
    }}>{`/watchlist_screening/entity/get`}</h4>
    <Schema method='POST' route='/watchlist_screening/entity/get' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/watchlist_screening/entity/get' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: WatchlistScreeningEntityGetRequest = {
  entity_watchlist_screening_id: 'entscr_52xR9LKo77r1Np',
};

try {
  const response = await client.watchlistScreeningEntityGet(request);
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`const request: Plaid.WatchlistScreeningEntityGetRequest = {
  entity_watchlist_screening_id: 'entscr_52xR9LKo77r1Np',
};

try {
  const response = await client.watchlistScreeningEntity.get(request);
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/watchlist_screening/entity/get \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "entity_watchlist_screening_id": "entscr_52xR9LKo77r1Np"
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::WatchlistScreeningEntityGetRequest.new(
  {
    entity_watchlist_screening_id: 'entscr_52xR9LKo77r1Np'
  }
)

response = client.watchlist_screening_entity_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`WatchlistScreeningEntityGetRequest request = new WatchlistScreeningEntityGetRequest()
  .entityWatchlistScreeningId("entscr_52xR9LKo77r1Np");

Response<WatchlistScreeningEntityGetResponse> response = client()
  .watchlistScreeningEntityGet(request)
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = WatchlistScreeningEntityGetRequest(
  entity_watchlist_screening_id='entscr_52xR9LKo77r1Np',
)
response = client.watchlist_screening_entity_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewWatchlistScreeningEntityGetRequest("entscr_52xR9LKo77r1Np")

response, _, err := client.PlaidApi.
  WatchlistScreeningEntityGet(ctx).
  WatchlistScreeningEntityGetRequest(*request).
  Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.WatchlistScreeningEntityGetRequest{EntityWatchlistScreeningID: "entscr_52xR9LKo77r1Np"}

response, err := client.WatchlistScreeningEntity.Get(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/watchlist_screening/entity/get' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "watchlist_screeningentitylist"
    }}>{`/watchlist_screening/entity/list`}</h4>
    <Schema method='POST' route='/watchlist_screening/entity/list' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/watchlist_screening/entity/list' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: WatchlistScreeningEntityListRequest = {
  entity_watchlist_program_id: 'entprg_2eRPsDnL66rZ7H',
};

try {
  const response = await client.watchlistScreeningEntityList(request);
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`const request: Plaid.WatchlistScreeningEntityListRequest = {
  entity_watchlist_program_id: 'entprg_2eRPsDnL66rZ7H',
};

try {
  const response = (await client.watchlistScreeningEntity.list(request))
    .response;
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/watchlist_screening/entity/list \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "entity_watchlist_program_id": "entprg_2eRPsDnL66rZ7H"
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::WatchlistScreeningEntityListRequest.new(
  {
    entity_watchlist_program_id: 'entprg_2eRPsDnL66rZ7H'
  }
)

response = client.watchlist_screening_entity_list(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`WatchlistScreeningEntityListRequest request = new WatchlistScreeningEntityListRequest()
  .entityWatchlistProgramId("entprg_2eRPsDnL66rZ7H");

Response<WatchlistScreeningEntityListResponse> response = client()
  .watchlistScreeningEntityList(request)
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = WatchlistScreeningEntityListRequest(
  entity_watchlist_program_id='entprg_2eRPsDnL66rZ7H'
)
response = client.watchlist_screening_entity_list(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewWatchlistScreeningEntityListRequest("entprg_2eRPsDnL66rZ7H")

response, _, err := client.PlaidApi.
  WatchlistScreeningEntityList(ctx).
  WatchlistScreeningEntityListRequest(*request).
  Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.WatchlistScreeningEntityListRequest{EntityWatchlistProgramID: "entprg_2eRPsDnL66rZ7H"}

response, err := client.WatchlistScreeningEntity.List(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/watchlist_screening/entity/list' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "watchlist_screeningentityupdate"
    }}>{`/watchlist_screening/entity/update`}</h4>
    <Schema method='POST' route='/watchlist_screening/entity/update' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/watchlist_screening/entity/update' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: WatchlistScreeningEntityUpdateRequest = {
  entity_watchlist_screening_id: 'entscr_52xR9LKo77r1Np',
  status: 'cleared',
};

try {
  const response = await client.watchlistScreeningEntityUpdate(request);
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`const request: Plaid.WatchlistScreeningEntityUpdateRequest = {
  entity_watchlist_screening_id: 'entscr_52xR9LKo77r1Np',
  status: 'cleared',
};

try {
  const response = await client.watchlistScreeningEntity.update(request);
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/watchlist_screening/entity/update \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "entity_watchlist_screening_id": "entscr_52xR9LKo77r1Np",
  "status": "cleared"
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::WatchlistScreeningEntityUpdateRequest.new(
  {
    entity_watchlist_screening_id: 'entscr_52xR9LKo77r1Np',
    status: 'cleared'
  }
)

response = client.watchlist_screening_entity_update(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`WatchlistScreeningEntityUpdateRequest request = new WatchlistScreeningEntityUpdateRequest()
  .entityWatchlistScreeningId("entscr_52xR9LKo77r1Np")
  .status(WatchlistScreeningStatus.CLEARED);

Response<WatchlistScreeningEntityUpdateResponse> response = client()
  .watchlistScreeningEntityUpdate(request)
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = WatchlistScreeningEntityUpdateRequest(
  entity_watchlist_screening_id='entscr_52xR9LKo77r1Np',
  status=WatchlistScreeningStatus('cleared'),
)
response = client.watchlist_screening_entity_update(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewWatchlistScreeningEntityUpdateRequest("entscr_52xR9LKo77r1Np")
request.SetStatus(plaid.WATCHLISTSCREENINGSTATUS_CLEARED)

response, _, err := client.PlaidApi.
  WatchlistScreeningEntityUpdate(ctx).
  WatchlistScreeningEntityUpdateRequest(*request).
  Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.WatchlistScreeningEntityUpdateRequest{EntityWatchlistScreeningID: "entscr_52xR9LKo77r1Np"}
request.Status = plaid.WatchlistScreeningStatus(plaid.WatchlistScreeningStatusCleared).Ptr()

response, err := client.WatchlistScreeningEntity.Update(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/watchlist_screening/entity/update' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "watchlist_screeningentityhistorylist"
    }}>{`/watchlist_screening/entity/history/list`}</h4>
    <Schema method='POST' route='/watchlist_screening/entity/history/list' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/watchlist_screening/entity/history/list' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: WatchlistScreeningEntityHistoryListRequest = {
  entity_watchlist_screening_id: 'entscr_52xR9LKo77r1Np',
};

try {
  const response = await client.watchlistScreeningEntityHistoryList(request);
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`const request: Plaid.WatchlistScreeningEntityHistoryListRequest = {
  entity_watchlist_screening_id: 'entscr_52xR9LKo77r1Np',
};

try {
  const response = (await client.watchlistScreeningEntity.listHistory(request))
    .response;
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/watchlist_screening/entity/history/list \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "entity_watchlist_screening_id": "entscr_52xR9LKo77r1Np"
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::WatchlistScreeningEntityHistoryListRequest.new(
  {
    entity_watchlist_screening_id: 'entscr_52xR9LKo77r1Np'
  }
)

response = client.watchlist_screening_entity_history_list(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`WatchlistScreeningEntityHistoryListRequest request = new WatchlistScreeningEntityHistoryListRequest()
  .entityWatchlistScreeningId("entscr_52xR9LKo77r1Np");

Response<WatchlistScreeningEntityHistoryListResponse> response = client()
  .watchlistScreeningEntityHistoryList(request)
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = WatchlistScreeningEntityHistoryListRequest(
  entity_watchlist_screening_id='entscr_52xR9LKo77r1Np',
)
response = client.watchlist_screening_entity_history_list(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewWatchlistScreeningEntityHistoryListRequest("entscr_52xR9LKo77r1Np")

response, _, err := client.PlaidApi.
  WatchlistScreeningEntityHistoryList(ctx).
  WatchlistScreeningEntityHistoryListRequest(*request).
  Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.WatchlistScreeningEntityHistoryListRequest{EntityWatchlistScreeningID: "entscr_52xR9LKo77r1Np"}

response, err := client.WatchlistScreeningEntity.ListHistory(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/watchlist_screening/entity/history/list' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "watchlist_screeningentityreviewcreate"
    }}>{`/watchlist_screening/entity/review/create`}</h4>
    <Schema method='POST' route='/watchlist_screening/entity/review/create' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/watchlist_screening/entity/review/create' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: WatchlistScreeningEntityReviewCreateRequest = {
  confirmed_hits: ['enthit_52xR9LKo77r1Np'],
  dismissed_hits: [],
  entity_watchlist_screening_id: 'entscr_52xR9LKo77r1Np',
};

try {
  const response = await client.watchlistScreeningEntityReviewCreate(request);
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`const request: Plaid.WatchlistScreeningEntityReviewCreateRequest = {
  confirmed_hits: ['enthit_52xR9LKo77r1Np'],
  dismissed_hits: [],
  entity_watchlist_screening_id: 'entscr_52xR9LKo77r1Np',
};

try {
  const response = await client.watchlistScreeningEntity.createReview(request);
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/watchlist_screening/entity/review/create \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "confirmed_hits": [
    "enthit_52xR9LKo77r1Np"
  ],
  "dismissed_hits": [],
  "entity_watchlist_screening_id": "entscr_52xR9LKo77r1Np"
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::WatchlistScreeningEntityReviewCreateRequest.new(
  {
    confirmed_hits: ['enthit_52xR9LKo77r1Np'],
    dismissed_hits: [],
    entity_watchlist_screening_id: 'entscr_52xR9LKo77r1Np'
  }
)

response = client.watchlist_screening_entity_review_create(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`List<String> confirmedHits = new ArrayList<String>();
confirmedHits.add("enthit_52xR9LKo77r1Np");

List<String> dismissedHits = new ArrayList<String>();

WatchlistScreeningEntityReviewCreateRequest request = new WatchlistScreeningEntityReviewCreateRequest()
  .confirmedHits(confirmedHits)
  .dismissedHits(dismissedHits)
  .entityWatchlistScreeningId("entscr_52xR9LKo77r1Np");

Response<WatchlistScreeningEntityReviewCreateResponse> response = client()
  .watchlistScreeningEntityReviewCreate(request)
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = WatchlistScreeningEntityReviewCreateRequest(
  confirmed_hits=["enthit_52xR9LKo77r1Np"],
  dismissed_hits=[],
  entity_watchlist_screening_id="entscr_52xR9LKo77r1Np",
)
response = client.watchlist_screening_entity_review_create(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewWatchlistScreeningEntityReviewCreateRequest(
  []string{"enthit_52xR9LKo77r1Np"},
  []string{},
  "entscr_52xR9LKo77r1Np",
)

response, _, err := client.PlaidApi.
  WatchlistScreeningEntityReviewCreate(ctx).
  WatchlistScreeningEntityReviewCreateRequest(*request).
  Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.WatchlistScreeningEntityReviewCreateRequest{
    ConfirmedHits:              []string{"enthit_52xR9LKo77r1Np"},
    DismissedHits:              []string{},
    EntityWatchlistScreeningID: "entscr_52xR9LKo77r1Np",
}

response, err := client.WatchlistScreeningEntity.CreateReview(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/watchlist_screening/entity/review/create' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "watchlist_screeningentityreviewlist"
    }}>{`/watchlist_screening/entity/review/list`}</h4>
    <Schema method='POST' route='/watchlist_screening/entity/review/list' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/watchlist_screening/entity/review/list' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: WatchlistScreeningEntityReviewListRequest = {
  entity_watchlist_screening_id: 'entscr_52xR9LKo77r1Np',
};

try {
  const response = await client.watchlistScreeningEntityReviewList(request);
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`const request: Plaid.WatchlistScreeningEntityReviewListRequest = {
  entity_watchlist_screening_id: 'entscr_52xR9LKo77r1Np',
};

try {
  const response = (await client.watchlistScreeningEntity.listReviews(request))
    .response;
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/watchlist_screening/entity/review/list \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "entity_watchlist_screening_id": "entscr_52xR9LKo77r1Np"
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::WatchlistScreeningEntityReviewListRequest.new(
  {
    entity_watchlist_screening_id: 'entscr_52xR9LKo77r1Np'
  }
)

response = client.watchlist_screening_entity_review_list(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`WatchlistScreeningEntityReviewListRequest request = new WatchlistScreeningEntityReviewListRequest()
  .entityWatchlistScreeningId("entscr_52xR9LKo77r1Np");

Response<WatchlistScreeningEntityReviewListResponse> response = client()
  .watchlistScreeningEntityReviewList(request)
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = WatchlistScreeningEntityReviewListRequest(
  entity_watchlist_screening_id='entscr_52xR9LKo77r1Np',
)
response = client.watchlist_screening_entity_review_list(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewWatchlistScreeningEntityReviewListRequest("entscr_52xR9LKo77r1Np")

response, _, err := client.PlaidApi.
  WatchlistScreeningEntityReviewList(ctx).
  WatchlistScreeningEntityReviewListRequest(*request).
  Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.WatchlistScreeningEntityReviewListRequest{EntityWatchlistScreeningID: "entscr_52xR9LKo77r1Np"}

response, err := client.WatchlistScreeningEntity.ListReviews(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/watchlist_screening/entity/review/list' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "watchlist_screeningentityhitlist"
    }}>{`/watchlist_screening/entity/hit/list`}</h4>
    <Schema method='POST' route='/watchlist_screening/entity/hit/list' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/watchlist_screening/entity/hit/list' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: WatchlistScreeningEntityHitListRequest = {
  entity_watchlist_screening_id: 'entscr_52xR9LKo77r1Np',
};

try {
  const response = await client.watchlistScreeningEntityHitList(request);
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`const request: Plaid.WatchlistScreeningEntityHitListRequest = {
  entity_watchlist_screening_id: 'entscr_52xR9LKo77r1Np',
};

try {
  const response = (await client.watchlistScreeningEntity.listHits(request))
    .response;
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/watchlist_screening/entity/hit/list \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "entity_watchlist_screening_id": "entscr_52xR9LKo77r1Np"
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::WatchlistScreeningEntityHitListRequest.new(
  {
    entity_watchlist_screening_id: 'entscr_52xR9LKo77r1Np'
  }
)

response = client.watchlist_screening_entity_hit_list(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`WatchlistScreeningEntityHitListRequest request = new WatchlistScreeningEntityHitListRequest()
  .entityWatchlistScreeningId("entscr_52xR9LKo77r1Np");

Response<WatchlistScreeningEntityHitListResponse> response = client()
  .watchlistScreeningEntityHitList(request)
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = WatchlistScreeningEntityHitListRequest(
  entity_watchlist_screening_id='entscr_52xR9LKo77r1Np',
)
response = client.watchlist_screening_entity_hit_list(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewWatchlistScreeningEntityHitListRequest("entscr_52xR9LKo77r1Np")

response, _, err := client.PlaidApi.
  WatchlistScreeningEntityHitList(ctx).
  WatchlistScreeningEntityHitListRequest(*request).
  Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.WatchlistScreeningEntityHitListRequest{EntityWatchlistScreeningID: "entscr_52xR9LKo77r1Np"}

response, err := client.WatchlistScreeningEntity.ListHits(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/watchlist_screening/entity/hit/list' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "watchlist_screeningentityprogramget"
    }}>{`/watchlist_screening/entity/program/get`}</h4>
    <Schema method='POST' route='/watchlist_screening/entity/program/get' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/watchlist_screening/entity/program/get' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: WatchlistScreeningEntityProgramGetRequest = {
  entity_watchlist_program_id: 'entprg_2eRPsDnL66rZ7H',
};

try {
  const response = await client.watchlistScreeningEntityProgramGet(request);
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`const request: Plaid.WatchlistScreeningEntityProgramGetRequest = {
  entity_watchlist_program_id: 'entprg_2eRPsDnL66rZ7H',
};

try {
  const response = await client.watchlistScreeningEntity.getProgram(request);
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/watchlist_screening/entity/program/get \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "entity_watchlist_program_id": "entprg_2eRPsDnL66rZ7H"
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::WatchlistScreeningEntityProgramGetRequest.new(
  {
    entity_watchlist_program_id: 'entprg_2eRPsDnL66rZ7H'
  }
)

response = client.watchlist_screening_entity_program_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`WatchlistScreeningEntityProgramGetRequest request = new WatchlistScreeningEntityProgramGetRequest()
  .entityWatchlistProgramId("entprg_2eRPsDnL66rZ7H");

Response<WatchlistScreeningEntityProgramGetResponse> response = client()
  .watchlistScreeningEntityProgramGet(request)
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = WatchlistScreeningEntityProgramGetRequest(
  entity_watchlist_program_id='entprg_2eRPsDnL66rZ7H',
)
response = client.watchlist_screening_entity_program_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewWatchlistScreeningEntityProgramGetRequest("entprg_2eRPsDnL66rZ7H")

response, _, err := client.PlaidApi.
  WatchlistScreeningEntityProgramGet(ctx).
  WatchlistScreeningEntityProgramGetRequest(*request).
  Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.WatchlistScreeningEntityProgramGetRequest{EntityWatchlistProgramID: "entprg_2eRPsDnL66rZ7H"}

response, err := client.WatchlistScreeningEntity.GetProgram(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/watchlist_screening/entity/program/get' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "watchlist_screeningentityprogramlist"
    }}>{`/watchlist_screening/entity/program/list`}</h4>
    <Schema method='POST' route='/watchlist_screening/entity/program/list' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/watchlist_screening/entity/program/list' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`try {
  const response = await client.watchlistScreeningEntityProgramList({});
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`try {
  const response = (await client.watchlistScreeningEntity.listPrograms({}))
    .response;
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/watchlist_screening/entity/program/list \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`response = client.watchlist_screening_entity_program_list({})
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`Response<WatchlistScreeningEntityProgramListResponse> response = client()
  .watchlistScreeningEntityProgramList(new WatchlistScreeningEntityProgramListRequest())
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = WatchlistScreeningEntityProgramListRequest(
  cursor='eyJkaXJlY3Rpb24iOiJuZXh0Iiwib2Zmc2V0IjoiMTU5NDM',
)
response = client.watchlist_screening_entity_program_list(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewWatchlistScreeningEntityProgramListRequest()

response, _, err := client.PlaidApi.
  WatchlistScreeningEntityProgramList(ctx).
  WatchlistScreeningEntityProgramListRequest(*request).
  Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.WatchlistScreeningEntityProgramListRequest{}

response, err := client.WatchlistScreeningEntity.ListPrograms(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/watchlist_screening/entity/program/list' type='response' mdxType="Schema" />
    <h3 {...{
      "id": "webhooks"
    }}>{`Webhooks`}</h3>
    <h4 {...{
      "id": "screening-status_updated"
    }}><inlineCode parentName="h4">{`SCREENING: STATUS_UPDATED`}</inlineCode></h4>
    <Schema model='ScreeningStatusUpdatedWebhook' type='model' mdxType="Schema" />
    <h4 {...{
      "id": "entity_screening-status_updated"
    }}><inlineCode parentName="h4">{`ENTITY_SCREENING: STATUS_UPDATED`}</inlineCode></h4>
    <Schema model='EntityScreeningStatusUpdatedWebhook' type='model' mdxType="Schema" />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "endpoints",
        level: 3,
        title: "Endpoints",
      },
{
        id: "watchlist_screeningindividualcreate",
        level: 4,
        title: "/watchlist_screening/individual/create",
      },
{
        id: "watchlist_screeningindividualget",
        level: 4,
        title: "/watchlist_screening/individual/get",
      },
{
        id: "watchlist_screeningindividuallist",
        level: 4,
        title: "/watchlist_screening/individual/list",
      },
{
        id: "watchlist_screeningindividualupdate",
        level: 4,
        title: "/watchlist_screening/individual/update",
      },
{
        id: "watchlist_screeningindividualhistorylist",
        level: 4,
        title: "/watchlist_screening/individual/history/list",
      },
{
        id: "watchlist_screeningindividualreviewcreate",
        level: 4,
        title: "/watchlist_screening/individual/review/create",
      },
{
        id: "watchlist_screeningindividualreviewlist",
        level: 4,
        title: "/watchlist_screening/individual/review/list",
      },
{
        id: "watchlist_screeningindividualhitlist",
        level: 4,
        title: "/watchlist_screening/individual/hit/list",
      },
{
        id: "watchlist_screeningindividualprogramget",
        level: 4,
        title: "/watchlist_screening/individual/program/get",
      },
{
        id: "watchlist_screeningindividualprogramlist",
        level: 4,
        title: "/watchlist_screening/individual/program/list",
      },
{
        id: "watchlist_screeningentitycreate",
        level: 4,
        title: "/watchlist_screening/entity/create",
      },
{
        id: "watchlist_screeningentityget",
        level: 4,
        title: "/watchlist_screening/entity/get",
      },
{
        id: "watchlist_screeningentitylist",
        level: 4,
        title: "/watchlist_screening/entity/list",
      },
{
        id: "watchlist_screeningentityupdate",
        level: 4,
        title: "/watchlist_screening/entity/update",
      },
{
        id: "watchlist_screeningentityhistorylist",
        level: 4,
        title: "/watchlist_screening/entity/history/list",
      },
{
        id: "watchlist_screeningentityreviewcreate",
        level: 4,
        title: "/watchlist_screening/entity/review/create",
      },
{
        id: "watchlist_screeningentityreviewlist",
        level: 4,
        title: "/watchlist_screening/entity/review/list",
      },
{
        id: "watchlist_screeningentityhitlist",
        level: 4,
        title: "/watchlist_screening/entity/hit/list",
      },
{
        id: "watchlist_screeningentityprogramget",
        level: 4,
        title: "/watchlist_screening/entity/program/get",
      },
{
        id: "watchlist_screeningentityprogramlist",
        level: 4,
        title: "/watchlist_screening/entity/program/list",
      },
{
        id: "webhooks",
        level: 3,
        title: "Webhooks",
      },
{
        id: "screening-status_updated",
        level: 4,
        title: "SCREENING: STATUS_UPDATED",
      },
{
        id: "entity_screening-status_updated",
        level: 4,
        title: "ENTITY_SCREENING: STATUS_UPDATED",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
